import { normalizeNumber } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_SUBSCRIPTION_COUNTRY_STAFF_COUNT = createFcmConfig('subscription_country_staff_count', {
	normalizer: normalizeNumber,
	defaultValue: 0,
});
